// Painted stills of each journey stage (captured from the full journeys), for the calm telling.
export const CALM_SCENES = {};
